module.exports = __webpack_public_path__ + "media/src/images/icons/contact_color-e9eb51aad2fc696c9d84014f8b9c1463.svg";